<div class="container mt-4 mb-5">
  <div class="row">
    <div class="col-lg-2 mb-3 pr-3" style="padding-left: 0 !important">
      <h4 i18n>Relatorios</h4>
      <div class="gcc-menudrop dropdown-menu">
        <div>
          <a class="dropdown-item anchor-select">
            Venda no periodo
          </a>
        </div>
      </div>
    </div>
    <div class="col-10">
      <div class="col-lg-12">
        <h5 i18n>Vendas no periodo</h5>
        <div>
          <form [formGroup]="formSearch">
            <div class="row">
              <div class="form-group">
                <label i18n>Data</label>
                <input type="text" class="form-control form-control-sm" bsDaterangepicker formControlName="data"
                  placement="bottom left" [bsConfig]="{
                    isAnimated: true,
                    dateInputFormat: 'DD-MM-YYYY',
                    ranges: ranges
                  }" />
              </div>
              <div class="col-1 align-self-center">
                <button [disabled]="loading" type="submit" class="btn btn-primary"  i18n (click)="filterData()">
                  {{loading ? "Aguarde..." : "Filtrar"}}
                </button>
              </div>
            </div>
          </form>
        </div>
        <div *ngIf="!loading && linhas.length > 0">
          <nested-table [data]="linhas"></nested-table>
        </div>
        <div *ngIf="linhas.length === 0">
          <span>
            Nenhum Registro enconrado!
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

